import React from "react";

import { BorderedBlock } from "../../../../../common-attributes/components/bordered-block/bordered-block.component";
import { SelectField } from "../../../../../forms/fields/select-field/select-field.component";
import { TextField } from "../../../../../forms/fields/text-field/text-field.component";

import { adSectionData } from "../../types/ad-section/ad-section-data.constant";

import { AdSectionProps } from "./ad-section.props";

export const AdSection = (props: AdSectionProps) => {
  const adMediumFieldName = "adMedium";
  const adTypeFieldName = "adType";
  const adFormatFieldName = "adFormat";
  const adSpecificationsFieldName = "adSpecifications";

  const handleAdMediumChange = () => {
    props.form.setValue(adTypeFieldName, "");
    props.form.setValue(adFormatFieldName, "");
    props.form.setValue(adSpecificationsFieldName, "");
  };

  const handleAdTypeChange = () => {
    props.form.setValue(adFormatFieldName, "");
    props.form.setValue(adSpecificationsFieldName, "");
  };

  const handleAdFormatChange = (event: React.ChangeEvent<any>) => {
    const selected = event.target.value;
    const value =
      adSectionData
        .filter((medium) => medium.mediumId === props.form.getValues(adMediumFieldName))[0]
        ?.adTypes.filter((type) => type.adTypeId === props.form.getValues(adTypeFieldName))[0]
        ?.adFormats.filter((format) => format.adFormatId === selected)[0]?.specifications ?? "";

    props.form.setValue(adSpecificationsFieldName, value);
  };

  const adMediumOptions = adSectionData.map((medium) => ({
    value: medium.mediumId,
    label: medium.mediumName,
  }));

  const adTypeOptions = () =>
    adSectionData
      .filter((medium) => medium.mediumId === props.form.getValues(adMediumFieldName))[0]
      ?.adTypes.map((type) => ({ value: type.adTypeId, label: type.adTypeName })) ?? [];

  const adFormatOptions = () =>
    adSectionData
      .filter((medium) => medium.mediumId === props.form.getValues(adMediumFieldName))[0]
      ?.adTypes.filter((type) => type.adTypeId === props.form.getValues(adTypeFieldName))[0]
      ?.adFormats.map((format) => ({ value: format.adFormatId, label: format.adFormatName })) ?? [];

  return (
    <BorderedBlock>
      <SelectField
        form={props.form}
        label="Ad Medium"
        name={adMediumFieldName}
        onChange={handleAdMediumChange}
        options={adMediumOptions}
        required
        userPermissions={props.userPermissions}
      />
      <SelectField
        form={props.form}
        label="Ad Type"
        name={adTypeFieldName}
        onChange={handleAdTypeChange}
        options={adTypeOptions()}
        required
        userPermissions={props.userPermissions}
      />
      <SelectField
        form={props.form}
        label="Ad Format"
        name={adFormatFieldName}
        onChange={handleAdFormatChange}
        options={adFormatOptions()}
        required
        userPermissions={props.userPermissions}
      />
      <TextField
        form={props.form}
        label="Ad Specifications"
        multiline
        name={adSpecificationsFieldName}
        required
        rows={3}
        userPermissions={props.userPermissions}
      />
    </BorderedBlock>
  );
};
